import { HashRouter } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Resume from './components/Resume';
import Contact from './components/Contact';
import Experience from './components/Experience';

export default function App() {
  return (
    <HashRouter>
      <div className="bg-gray-950 text-white">
        <Navbar />
        <Hero />
        <Experience />
        <Skills />
        <Projects />
        <Resume />
        <Contact />
      </div>
    </HashRouter>
  );
}